import { render } from "./Summaryuserinfo.vue?vue&type=template&id=0b2929d6&scoped=true"
import script from "./Summaryuserinfo.vue?vue&type=script&lang=js"
export * from "./Summaryuserinfo.vue?vue&type=script&lang=js"

import "./Summaryuserinfo.vue?vue&type=style&index=0&id=0b2929d6&scoped=true&lang=css"

import exportComponent from "/Users/alexisbailly/Documents/Programming/Website/vueform/Wealth & Retirement/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b2929d6"]])

export default __exports__